import { render, staticRenderFns } from "./ImprovementStatusPortlet.vue?vue&type=template&id=49d95986&scoped=true"
import script from "./ImprovementStatusPortlet.vue?vue&type=script&lang=js"
export * from "./ImprovementStatusPortlet.vue?vue&type=script&lang=js"
import style0 from "./ImprovementStatusPortlet.vue?vue&type=style&index=0&id=49d95986&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d95986",
  null
  
)

export default component.exports